var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "80vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      on: { hide: _vm.hideModal },
      model: {
        value: _vm.show_modal,
        callback: function($$v) {
          _vm.show_modal = $$v
        },
        expression: "show_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    return _vm.hideModalNews()
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.single_news.title) +
                    "\n                "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.single_news.content) }
              }),
              _vm.useCommentsNews
                ? _c(
                    "q-tabs",
                    {
                      staticClass: "q-mt-xl",
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "comments",
                          label: _vm.$t("comments")
                        },
                        slot: "title"
                      }),
                      _c("q-tab-pane", { attrs: { name: "comments" } }, [
                        _c("div", { staticClass: "row gutter-sm" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("q-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: "3",
                                  "float-label": _vm.$t("comment"),
                                  error: _vm.$v.comment.$error
                                },
                                on: { input: _vm.$v.comment.$touch },
                                model: {
                                  value: _vm.comment,
                                  callback: function($$v) {
                                    _vm.comment = $$v
                                  },
                                  expression: "comment"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "row gutter-sm justify-end q-mt-sm" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-xs-12 col-sm-3",
                                class: _vm.getOrder("cancel")
                              },
                              [
                                _c("q-btn", {
                                  staticClass: "full-width",
                                  attrs: {
                                    color: "tertiary",
                                    label: _vm.$t("cancel"),
                                    icon: "far fa-chevron-left"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.hideModalNews()
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col-xs-12 col-sm-3",
                                class: _vm.getOrder("save")
                              },
                              [
                                _c("q-btn", {
                                  staticClass: "full-width",
                                  attrs: {
                                    color: "secondary",
                                    label: _vm.$t("save"),
                                    icon: "far fa-save"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.saveComment()
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm.comments.length > 0
                          ? _c(
                              "div",
                              { staticClass: "row gutter-sm q-mt-sm" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    _c(
                                      "q-list",
                                      { attrs: { separator: "" } },
                                      [
                                        _c(
                                          "q-list-header",
                                          { attrs: { inset: "" } },
                                          [_vm._v(_vm._s(_vm.$t("comments")))]
                                        ),
                                        _vm._l(_vm.comments, function(
                                          c,
                                          index
                                        ) {
                                          return _c(
                                            "q-item",
                                            { key: index },
                                            [
                                              _c("q-item-side", {
                                                attrs: {
                                                  avatar: c.user_image
                                                    ? c.user_image
                                                    : _vm.getPlaceholder
                                                }
                                              }),
                                              _c(
                                                "q-item-main",
                                                [
                                                  _c(
                                                    "q-item-tile",
                                                    { attrs: { label: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(c.user_name)
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "q-item-tile",
                                                    { attrs: { sublabel: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.fDate(
                                                            c.created_date
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "q-item-tile",
                                                    { attrs: { sublabel: "" } },
                                                    [_vm._v(_vm._s(c.comment))]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.id_user === c.user_id
                                                ? _c(
                                                    "q-item-side",
                                                    { attrs: { right: "" } },
                                                    [
                                                      _c("q-btn", {
                                                        attrs: {
                                                          flat: "",
                                                          round: "",
                                                          color: "negative",
                                                          icon:
                                                            "fal fa-trash-alt"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.DeleteComments(
                                                              c.id
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }